var __TEMP__ = require('./_arrayEach.js');var arrayEach = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseAssignValue.js');var baseAssignValue = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./bind.js');var bind = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_flatRest.js');var flatRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = flatRest(function(object, methodNames) {
  arrayEach(methodNames, function(key) {
    key = toKey(key);
    baseAssignValue(object, key, bind(object[key], object));
  });
  return object;
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = bindAll;
